<template>
  <scout-tab-panel
    :is-active="isActive"
    title="いいね済み"
    name="like"
    :link="link"
  />
</template>

<script>
import ScoutTabPanel from '@/components/atoms/ScoutTabPanel'

export default {
  components: { ScoutTabPanel },
  computed: {
    isActive () {
      return this.$route.path.includes('/liked')
    },
    link () {
      return { name: 'scoutLiked' }
    }
  }
}

</script>
